<span class="font-medium-title-large">{{ title }}</span>
<span class="font-regular-body-large">
  Schreibe die Notiz, die du diesem Benutzer zuordnen möchtest, in das folgende
  Textfeld.
</span>
<form
  [formGroup]="noteForm"
  class="flex-c gap-32 align-self-stretch"
  (ngSubmit)="saveNote()">
  <div class="input-field">
    <div class="input-label-wrapper">
      <label for="note" class="input-label"> Notiz für Nutzer </label>
      <div class="input-label-hint">
        {{ getTextAreaLength(noteForm.controls['note']) }} /
        {{ 1200 }}
      </div>
    </div>
    <textarea
      type="text"
      id="note"
      name="note"
      class="input-text"
      rows="5"
      placeholder="Erinnerungen, anstehende Aufgaben, die mit diesem Benutzer verknüpft sind, und mehr..."
      formControlName="note"></textarea>
  </div>
  <div class="flex-r gap-16 justify-center">
    <button
      type="button"
      class="inwi-text-button-large-secondary"
      (click)="closeDialog()">
      <div class="button-content">
        <div class="button-text">Abbrechen</div>
      </div>
    </button>
    <button
      type="submit"
      class="inwi-text-button-large-primary"
      [disabled]="noteForm.invalid">
      <div class="button-content">
        <div class="button-text">Speichern</div>
      </div>
    </button>
  </div>
</form>
